import moment from "moment";
import { useUser } from "../../../contexts/UserContext";
import { Conversation } from "../../../models/Conversation";
import { File } from "../../../models/File";
import { Message } from "../../../models/Message";
import AttachmentListItem from "./AttachmentListItem";
import { User } from "../../../models/User";
import { Text } from "../../../design/text";

interface MessageListItemProps {
  conversation: Conversation;
  message: Message;
}

const MessageListItem = ({ conversation, message }: MessageListItemProps) => {
  const { users } = useUser();

  const fromUser = users.find((u) => u._id === message.createdById);
  const recipientUsers = users.filter((u) =>
    conversation.userIds.includes(u._id),
  );

  return (
    <div className="w-full max-w-3xl p-4 mx-auto mb-6 bg-white border border-gray-200 rounded-md shadow-sm dark:bg-gray-900 dark:border-gray-700">
      {/* Email Header */}
      <div className="mb-4">
        <Text>
          From: <span className="font-semibold">{fromUser?.name}</span>{" "}
          &nbsp;|&nbsp; Sent:{" "}
          {moment(message.createdAt).format("MMM D, YYYY h:mm A")}
        </Text>
        <Text className="text-xs text-gray-500 dark:text-gray-400">
          To:{" "}
          <span className="font-semibold">
            {recipientUsers.map((u) => u.name).join(", ")}
          </span>
        </Text>
        <Text className="text-xs text-gray-500 dark:text-gray-400">
          Subject:{" "}
          <span className="font-semibold">
            {conversation.subject || "No Subject"}
          </span>
        </Text>
      </div>

      {/* Email Body */}
      <Text className="break-words whitespace-pre-wrap">{message.content}</Text>

      {/* Attachments */}
      {message.files && message.files.length > 0 && (
        <div className="pt-2 mt-4 border-t border-gray-200 dark:border-gray-700">
          <div className="mb-2 text-xs font-semibold text-gray-600 dark:text-gray-400">
            Attachments:
          </div>
          <div className="flex flex-col gap-2">
            {message.files?.map((file) => (
              <AttachmentListItem key={file._id} attachment={file} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MessageListItem;
